import conversationalCommerce from "@/services/conversational.commerce";
import notification from "@/services/notification";
import { getField, updateField } from "vuex-map-fields";
import auth from "./auth";

import SecureLS from "secure-ls";
const ls = new SecureLS({
  encodingType: "rc4",
  isCompression: false,
  encryptionSecret: "Zs%Ma??5Qn,!ZB#_nhM"
});

export default {
  namespaced: true,
  state: {
    loading: {
      brands: false,
      branches: false,
      categories: false,
      products: false,
      product: false,
      checkout_link: false,
      register: false,
      inbox: false,
      thread: false,
      cart: false,
      tracking_link: false,
      send_message: false,
      cart_quantity: false
    },
    selectedBrand: null,
    brands: [],
    selectedBranch: null,
    branches: [],
    branchesByBrand: [],
    selectedCategory: null,
    categories: [{ value: null, label: "All Products" }],
    products: [],
    product_keyword: null,
    errors: null,
    newOrderDetails: {
      first_name: null,
      last_name: null,
      mobile: null,
      email: null
    },
    inbox: [],
    selectedOrder: null,
    showCartItems: false,
    cartItems: null,
    viewProduct: null,
    products_pagination: {
      page: 1
    },
    inbox_pagination: {
      page: 1
    },
    thread: null,
    thread_pagination: {
      page: 1
    },
    links: {
      checkout: null,
      tracking: null
    },
    message_field: null,
    is_multiple_purchase_allowed: 0,
    order_status: "",
    order_status_errors: null
  },
  getters: {
    getField,
    loading: state => state.loading,
    brands: state => state.brands,
    selectedBrand: state => state.selectedBrand,
    branches: state => state.branches,
    branchesByBrand: state => state.branchesByBrand,
    selectedBranch: state => state.selectedBranch,
    selectedCategory: state => state.selectedCategory,
    categories: state => state.categories,
    products: state => state.products,
    newOrderDetails: state => state.newOrderDetails,
    errors: state => state.errors,
    inbox: state => state.inbox,
    selectedOrder: state => state.selectedOrder,
    showCartItems: state => state.showCartItems,
    cartItems: state => state.cartItems,
    viewProduct: state => state.viewProduct,
    products_pagination: state => state.products_pagination,
    inbox_pagination: state => state.inbox_pagination,
    thread: state => state.thread,
    thread_pagination: state => state.thread_pagination,
    links: state => state.links,
    isMultiplePurchaseAllowed: state => state.is_multiple_purchase_allowed,
    orderStatus: state => state.order_status,
    orderStatusErrors: state => state.order_status_errors
  },
  mutations: {
    updateField,
    setLoading(state, { type, value }) {
      state.loading[type] = value;
    },
    setSelectedBrand(state, brand) {
      state.selectedBrand = brand;
    },
    setSelectedBranch(state, branch) {
      state.selectedBranch = branch;
    },
    setSelectedCategory(state, category) {
      state.selectedCategory = category;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    addOrder(state, newOrder) {
      state.inbox.push(newOrder);
    },
    setInbox(state, { inbox, isInfinite }) {
      if (isInfinite) inbox.map(item => state.inbox.push(item));
      else state.inbox = inbox;
    },
    resetNewOrderDetails(state) {
      state.newOrderDetails = {
        first_name: null,
        last_name: null,
        mobile: null,
        email: null
      };
    },
    setSelectedOrder(state, { order, index }) {
      if (order) state.selectedOrder = order;
      else if (index) state.selectedOrder = state.inbox[index];
    },
    setShowCartItems(state, status) {
      state.showCartItems = status;
    },
    setCartItemQty(state, { method, item, branch }) {
      const quantity = Number(
        state.cartItems.list
        .find(branchA => branchA.branch_uuid === branch).items
        .find(itemA => itemA.uuid === item).quantity
      );
      if (method === 'subtract' && quantity > 0) {
        state.cartItems.list
        .find(branchA => branchA.branch_uuid === branch).items
        .find(itemA => itemA.uuid === item).quantity = quantity - 1;
      }
      else if (method === 'plus') {
        state.cartItems.list
        .find(branchA => branchA.branch_uuid === branch).items
        .find(itemA => itemA.uuid === item).quantity = quantity + 1;
      }
    },
    removeCartItem(state, index) {
      state.cartItems.list.items.splice(index, 1);
    },
    setViewProduct(state, product) {
      const otherDetails = {
        quantity: 1
      };
      state.viewProduct = product ? { ...product, ...otherDetails } : null;
    },
    setProductQuantity(state, { method }) {
      if (state.viewProduct) {
        const quantity = state.viewProduct.quantity;
        if (method === 'subtract' && quantity > 1) state.viewProduct.quantity = quantity - 1;
        else if (method === 'plus') state.viewProduct.quantity = quantity + 1;
        else if (method === 'reset') state.viewProduct.quantity = 1;
      }
    },
    setBrands(state, brands) {
      state.brands = brands.filter(brand => brand.visibility === true);
    },
    setBranches(state, branches) {
      state.branches = branches;
    },
    setBranchesByBrand(state) {
      state.branchesByBrand = state.branches.filter(branch => branch.brand_uuid === state.selectedBrand);
    },
    setCategories(state, categories) {
      const default_category = [{ value: null, label: "All Products" }];
      state.categories = default_category.concat(categories
        .map(category => category.category_details)
        .map(category => {
          return {
            value: category.uuid,
            label: category.name
          };
        })
      );
    },
    setProducts(state, { products, isInfinite }) {
      if (isInfinite) products.map(product => state.products.push(product))
      else state.products = products;
    },
    setPagination(state, { type, pagination }) {
      state[`${type}_pagination`] = pagination;
    },
    setThread(state, { thread, isInfinite}) {
      if (isInfinite) thread.map(item => state.thread.push(item));
      else state.thread = thread;
    },
    setCart(state, cart) {
      let deliveryFee = cart.fees.filter(fee => fee.name == 'Delivery_fee');
          deliveryFee.forEach(fee => cart.computed_total -= (Math.floor(fee.calculated_amount * 100) / 100));
      state.cartItems = cart;
    },
    setLinks(state, { type, url, validity }) {
      state.links[type] = {
        url: url,
        validity: validity
      };
    },
    resetSendMessage(state) {
      state.message_field = null;
    },
    resetThreadPanel(state) {
      state.selectedOrder = null;
      state.thread = null;
    },
    setIsMultiplePurchaseAllowed(state, value) {
      state.is_multiple_purchase_allowed = value;
    },
    setOrderStatus(state, status) {
      state.order_status = status;
    },
    setOrderStatusErrors(state, errors) {
      state.order_status_errors = errors;
    }
  },
  actions: {
    async getBrands({ commit }) {
      commit('setLoading', { type: 'brands', value: true });
      commit("setErrors", null);
      try {
        const brands = await conversationalCommerce.getBrands();
        commit("setBrands", brands);
      } catch (errors) {
        commit("setErrors", errors)
      } finally {
        commit("setLoading", { type: 'brands', value: false });
      }
    },
    async getBranches({ commit }) {
      commit("setLoading", { type: 'branches', value: true });
      commit("setErrors", null);
      try {
        const branches = await conversationalCommerce.getBranches();
        commit("setBranches", branches);
        commit("setBranchesByBrand");
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'branches', value: false });
      }
    },
    async getBrandCategories({ commit, state }) {
      commit("setLoading", { type: 'categories', value: true });
      commit("setErrors", null);
      try {
        const { list } = await conversationalCommerce.getBrandCategories(state.selectedBrand);
        commit("setCategories", list);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'categories', value: false });
      }
    },
    async getProducts({ commit }, page) {
      commit("setLoading", { type: 'products', value: true });
      commit("setProducts", { products: [], isInfinite: page > 1 });
      commit("setErrors", null);
      try {
        const response = await conversationalCommerce.getProducts(page);
        commit("setProducts", { products: response.list, isInfinite: page > 1 });
        const { list, message, ...pagination } = response;
        commit("setPagination", { type: 'products', pagination: { ...pagination, page: page } });
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'products', value: false });
      }
    },
    async getBranchProducts({ commit, state }) {
      commit("setLoading", { type: 'products', value: true });
      commit("setProducts", { products: [] });
      commit("setErrors", null);
      const payload = {
        brand_uuid: state.selectedBrand,
        branch_uuid: state.selectedBranch,
        param: {}
      };
      if (state.product_keyword) payload.param['search'] = state.product_keyword;
      if (state.selectedCategory) payload.param['category'] = state.selectedCategory;
      try {
        const { data } = await conversationalCommerce.getBranchProducts(payload);
        commit("setProducts", { products: data });
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'products', value: false });
      }
    },
    async getProductDetails({ commit, state }, { uuid, type })  {
      commit("setLoading", { type: 'product', value: true });
      commit("setErrors", null);
      const payload = {
        product_inventory_uuid: uuid,
        param: {
          branch_uuid: state.selectedBranch
        }
      };
      try {
        if (type === 'simple') {
          const { simple } = await conversationalCommerce.getBranchSimpleProductDetail(payload);
          commit("setViewProduct", simple);
        } else if (type === 'variable') {
          const { variable } = await conversationalCommerce.getVariableProductDetail(payload);
          commit("setViewProduct", variable);
        }
      } catch (errors) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", { type: 'product', value: false });
      }
    },
    async registGuestUser({ commit, state, dispatch }, payload) {
      commit("setLoading", { type: 'register', value: true });
      commit("setErrors", null);
      payload['brand_uuid'] = state.selectedBrand;
      try {
        const { message, data } = await conversationalCommerce.registGuestUser(payload);
        await dispatch("createCustomerInbox", data);
        await dispatch("getBrandInbox", { page: 1 });
        notification.success(message);
      } catch (error) {
        commit("setErrors", error.errors);
        notification.warning("Oops, something went wrong. Please try again.");
      } finally {
        commit("setLoading", { type: 'register', value: false });
      }
    },
    async createCustomerInbox({ commit, state, dispatch }, customer) {
      commit("setLoading",  { type: 'inbox', value: true });
      commit("setErrors", null);
      const payload = {
        brand_uuid: state.selectedBrand,
        param: {
          customer_uuid: customer.uuid,
          name: `${customer.first_name} ${customer.last_name}`
        }
      };
      try {
        const { message, data } = await conversationalCommerce.createCustomerInbox(payload);
        commit("setSelectedOrder", { order: data });
        dispatch("getCustomerCart");
        dispatch("getBrandThread");
        notification.success(message);
      } catch (errors) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", { type: 'inbox', value: false });
      }
    },
    async getBrandInbox({ commit, state }, query) {
      commit("setLoading", { type: 'inbox', value: true });
      commit("setErrors", null);
      const customer_uuid = query.customer_uuid;
      if (customer_uuid) delete query[customer_uuid];
      const payload = {
        brand_uuid: state.selectedBrand
      };
      if (query) {
        payload['param'] = query;
        if (query.page && query.page === 1) commit("setInbox", { inbox: [],  isInfinite: false });
      }
      try {
        const { data } = await conversationalCommerce.getBrandInbox(payload);
        commit("setInbox", { inbox: data.list,  isInfinite: query ? query.page > 1 : false });
        commit("setPagination", { type: 'inbox', pagination: { ...data.pagination, page: query ? query.page : 1 } });
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'inbox', value: false });
      }
    },
    async getBrandThread({ commit, state }, query) {
      commit("setLoading", { type: 'thread', value: true });
      commit("setErrors", null);
      const payload = {
        brand_uuid: state.selectedBrand,
        thread_uuid: state.selectedOrder.uuid
      };
      if (query) payload['param'] = query;
      else commit("setThread", { thread: null, isInfinite: false });
      try {
        const { data } = await conversationalCommerce.getBrandThread(payload);
        commit("setThread", { thread: data.list, isInfinite: query ? query.page > 1 : false });
        commit("setPagination", { type: 'thread', pagination: { ...data.pagination, page: query ? query.page : 1 } });
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'thread', value: false });
      }
    },
    async getCustomerCart({ commit, state }) {
      commit("setErrors", null);
      if (!state.cartItems) commit("setLoading", { type: 'cart', value: true });
      const payload = {
        customer_uuid: state.selectedOrder.customer_uuid,
        brand_uuid: state.selectedBrand,
        param: {
          brand_name: state.brands.find(brand => brand.uuid === state.selectedBrand).name,
          merchant_code: ls.get('merchantDetails').customer_app_credential[0].subdomain
        }
      };
      try {
        const { data } = await conversationalCommerce.getCustomerCart(payload);
        commit("setCart", data);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'cart', value: false });
      }
    },
    async addItemToCart({ commit, state, dispatch }, item) {
      commit("setLoading", { type: 'cart', value: true });
      commit("setErrors", null);
      const payload = {
        customer_uuid: state.selectedOrder.customer_uuid,
        brand_uuid: state.selectedBrand,
        param: {
          branch_uuid: state.selectedBranch,
          branch_name: state.branches.find(branch => branch.uuid === state.selectedBranch).name,
          product_inventory_uuid: item.product_inventory_uuid,
          quantity: item.quantity,
          remarks: item.remarks,
          add_ons_uuid: item.add_ons_uuid
        }
      };
      try {
        const { message } = await conversationalCommerce.addItemToCart(payload);
        await dispatch("getCustomerCart");
        notification.success(message);
      } catch (errors) {
        const { message } = errors.errors;
        commit("setErrors", errors);
        if (message) notification.warning(message);
        else notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", { type: 'cart', value: false });
      }
    },
    async updateCart({ commit, state, dispatch }, { item, branch, quantity }) {
      commit("setLoading", { type: 'cart_quantity', value: true  });
      commit("setErrors", null);
      const payload = {
        brand_uuid: state.selectedBrand,
        customer_uuid: state.selectedOrder.customer_uuid,
        cart_item_uuid: item,
        param: {
          quantity: quantity
        }
      };
      try {
        const { message } = await conversationalCommerce.updateCart(payload);
        notification.success(message);
        dispatch("getCustomerCart");
      } catch (errors) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", { type: 'cart_quantity', value: false  });
      }
    },
    async removeCartItem({ commit, state, dispatch }, cart_item_uuid) {
      commit("setLoading", { type: 'cart_quantity', value: true });
      commit("setErrors", null);
      const payload = {
        brand_uuid: state.selectedBrand,
        customer_uuid: state.selectedOrder.customer_uuid,
        cart_item_uuid: cart_item_uuid
      };
      try {
        const { message } = await conversationalCommerce.removeCartItem(payload);
        notification.success(message);
        dispatch("getCustomerCart");
      } catch (errors) {
        commit("setErrors", errors);
        notification.warning("Oops, something went wrong.");
      } finally {
        commit("setLoading", { type: 'cart_quantity', value: false });
      }
    },
    async getCheckoutLink({ commit, state }) {
      commit("setLoading",  { type: 'checkout_link', value: true });
      commit("setErrors", null);
      const payload = {
        customer_uuid: state.selectedOrder.customer_uuid,
        brand_uuid: state.selectedBrand
      };
      try {
        const { message, data } = await conversationalCommerce.getCheckoutLink(payload);
        commit("setLinks", {
          type: 'checkout',
          url: data.url,
          validity: data.checkout_valid_until,
          uuid: data.checkout_uuid
        });
        notification.success(message);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading",  { type: 'checkout_link', value: false });
      }
    },
    async getTrackingLink({ commit, state }) {
      commit("setLoading",  { type: 'tracking_link', value: true });
      commit("setErrors", null);
      try {
        const { message } = await conversationalCommerce.getTrackingLink(payload);
        commit("setLinks", {
          type: 'tracking',
          link: data.tracking_uuid,
          validity: data.tracking_valid_until
        });
        notification.success(message);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading",  { type: 'checkout_link', value: false });
      }
    },
    async sendMessage({ commit, state, dispatch }, msgPayload) {
      commit("setLoading", { type: 'send_message', value: true });
      commit("setErrors", null);
      const payload = {
        brand_uuid: state.selectedBrand,
        thread_uuid: state.selectedOrder.uuid,
        param: {
          message: msgPayload ? msgPayload : state.message_field,
          sender: 1
        }
      };
      try {
        const { message } = await conversationalCommerce.sendMessage(payload);
        notification.success(message);
        dispatch("getBrandThread");
        commit("resetSendMessage");
      } catch(errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", { type: 'send_message', value: false });
      }
    },
    async isMultiplePurchaseAllowed({ commit }) {
      commit("setErrors", null);
      const payload = {
        merchant_uuid: auth.state.user.merchant_uuid,
        param: {
          level: 'merchant'
        }
      };
      try {
        const { data } = await conversationalCommerce.isMultiplePurchaseAllowed(payload);
        commit("setIsMultiplePurchaseAllowed", data.allow_purchase_multiple)
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getCustomerOrderStatus({ commit, state }) {
      const payload = {
        customer_uuid: state.selectedOrder.customer_uuid,
        brand_uuid: state.selectedBrand
      };
      commit("setOrderStatus", "");
      commit("setOrderStatusErrors", null);
      try {
        const { order_status, tracking_uuid, tracking_valid_until, url } = await conversationalCommerce.getCustomerOrderStatus(payload);
        commit("setOrderStatus", order_status);
        commit("setLinks", {
          type: 'tracking',
          url: url,
          validity: tracking_valid_until,
          uuid: tracking_uuid
        });
      } catch (errors) {
        commit("setOrderStatusErrors", errors);
      }
    }
  }
}
